import ActivitiesList from "./ActivitiesList"

export default  ActivitiesList;
